import styled from '@tanium/react-emotion-9';

export const NoOverflow = styled('div')({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});
